import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {AuthService} from "../services/auth/auth.service";

export const authGuard: CanActivateFn = (route, state) => {
  let authService = inject(AuthService)
  let router = inject(Router)

  if (authService.user()?.token) {
    // Redirect to the app's main page (no '/dashboard' route exists)
    router.navigate(['/']);
    return false;
  } else {
    return true;
  }
};
